import React, { useState } from 'react'
import ReactMarkdown from 'react-markdown'

import { Container, PageHeader, RequestDeletion } from '../../components'

import filePath from '../../docs/privacy-policies/souacs.md'

export default () => {
  const [doc, setDoc] = useState('')

  fetch(filePath)
    .then(res => res.text())
    .then(text => setDoc(text))

  return (
    <>
      <PageHeader />
      <Container>
        <a href="/">{'< Voltar para o início'}</a>
        <section className="my-4">
          <ReactMarkdown>{doc}</ReactMarkdown>
          <RequestDeletion name="souACS" email="souacs" />
        </section>
      </Container>
    </>
  )
}
